<template>
  <v-container>
    <h3 class="mb-4">Docenti senza scuola valida</h3>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :options.sync="pagination"
      :loading="loading"
      hide-default-footer
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          v-if="can('edit teachers')"
          icon
          color="primary"
          :title="'Modifica docente'"
          @click="editTeacher(item)"
        >
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn
          v-if="can('delete teachers') && item.school_location_id"
          icon
          color="orange darken-2"
          :title="'Scollega il docente da questa sede'"
          @click="boxTeacherLocation(item)"
        >
          <v-icon>link_off</v-icon>
        </v-btn>
        <v-btn
          v-if="can('delete teachers')"
          icon
          color="red"
          :title="'Elimina definitivamente il docente'"
          @click="deleteTeacher(item)"
        >
          <v-icon>cancel</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchData"
    />
  </v-container>
</template>
<script>
import { mapActions } from 'vuex';

import { anomalyService } from '../../../utils/services/anomaly.service';
import { teachersService } from '../../../utils/services/teachers.service';
import Paginator from '../../../components/shared/Paginator';

export default {
  name: 'AnomalyOrphanTeachers',
  components: { Paginator },
  data() {
    return {
      loading: false,
      items: [],
      totalItems: 0,
      pagination: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
      },
      headers: [
        { text: 'Docente', value: 'docente' },
        { text: 'Teacher ID', value: 'teacher_id' },
        { text: 'Sede ID', value: 'school_location_id' },
        { text: 'Codice Sede', value: 'codice_sede' },
        { text: 'Scuola', value: 'scuola' },
        { text: 'Motivo', value: 'motivo' },
        { text: 'Cancellata il', value: 'sede_cancellata_il' },
        { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'right' },
      ],
    };
  },
  computed: {
    // Colonna e verso insieme: un clic sull'intestazione li cambia entrambi, una sola richiesta
    sortKey() {
      return JSON.stringify([this.pagination.sortBy, this.pagination.sortDesc]);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions('confirm', ['showConfirm']),
    ...mapActions('alert', ['showToast']),

    resetAndFetch() {
      this.pagination.page = 1;
      this.fetchData();
    },

    async fetchData() {
      this.loading = true;
      try {
        const { page, itemsPerPage, sortBy, sortDesc } = this.pagination;
        const response = await anomalyService.getOrphanTeachers({
          page,
          itemsPerPage,
          filters: sortBy.length ? { sortBy, sortDesc } : {},
        });
        this.items = response.data.data;
        this.totalItems = response.data.total;
        if (!this.items.length && this.pagination.page > 1) {
          this.pagination.page -= 1;
          await this.fetchData();
          return;
        }
      } catch (error) {
        this.handleError(error, this.errors);
      } finally {
        this.loading = false;
      }
    },

    editTeacher(item) {
      this.$router.push({
        path: `/teachers/${item.teacher_id}/show`,
        query: { tab: 'school', returnUrl: this.$route.path },
      });
    },

    boxTeacherLocation(item) {
      const sedeLabel = item.codice_sede
        ? `${item.scuola || ''} (${item.codice_sede})`.trim()
        : `sede ${item.school_location_id}`;
      this.showConfirm({
        message: `Cancellare definitivamente l'associazione del docente ${item.docente} con la scuola ${sedeLabel}? L'operazione è irreversibile.`,
        onConfirm: () => {
          this.loading = true;
          return teachersService.box(item.teacher_id, {
            school_location_id: item.school_location_id,
          })
            .then(() => {
              this.showToast({ type: 'success', message: 'Associazione cancellata' });
              this.fetchData();
            })
            .catch(error => {
              const data = (error && error.response && error.response.data) || {};
              const msg = data.message || data.error || 'Errore durante la cancellazione';
              this.showToast({ type: 'error', message: msg });
              this.loading = false;
            });
        },
      });
    },

    deleteTeacher(item) {
      this.showConfirm({
        message: `Eliminare definitivamente il docente ${item.docente}? L'operazione è irreversibile.`,
        onConfirm: () => {
          this.loading = true;
          return teachersService.remove(item.teacher_id)
            .then(() => {
              this.showToast({ type: 'success', message: this.$t('DELETED') });
              this.fetchData();
            })
            .catch(error => {
              const data = (error && error.response && error.response.data) || {};
              const msg = data.errors || data.message || 'Impossibile eliminare il docente';
              this.showToast({ type: 'error', message: msg });
              this.loading = false;
            });
        },
      });
    },
  },
  watch: {
    // L'ordinamento è lato server
    sortKey: 'resetAndFetch',
  },
};
</script>
